import './thesaurus-term-chooser-list.scss'

import Component from 'vue-class-component';

import { faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { FormApi } from 'final-form';
import { get, set } from 'lodash'
import { ThesaurusTermChooser } from '../..';
import { EnhancedTextArea } from '../enhanced-text-area';

let vForKey: number = 0;

@Component({
    components: {
        sEnhancedTextArea: EnhancedTextArea,
        sThesaurusTermChooser: ThesaurusTermChooser,
    },
    props: ['thesaurusIdentifiers', 'placeholders', 'name', 'subPaths', 'precisionSubPath', 'titles', 'form'],
    template: require('./thesaurus-term-chooser-list.html')
})
export class ThesaurusTermChooserList extends ReactiveVue {

    // The identifer of the thesaurus in the database (ex : material, typeOfAlteration, etc...)
    private thesaurusIdentifiers: string[]
    // A text corresponding to the value undefined, added on top of the options
    private placeholders: string[]

    public name: string;
    private titles: string[]
    private subPaths: string[]
    public precisionSubPath: string;
    public form: FormApi;

    // Icons
    public trashIcon = faTrash;
    public plusIcon = faPlusCircle;

    public entryFieldName(entryIndex: number, subPathIndex: number) {
        const subPathToAppend: string = this.subPaths[subPathIndex] ? `.${this.subPaths[subPathIndex]}` : '';
        return `${this.name}[${entryIndex}${subPathToAppend}`
    }
    public entryPrecisionFieldName(index: number) {
        const subPathToAppend: string = this.precisionSubPath ? `.${this.precisionSubPath}` : '';
        return `${this.name}[${index}${subPathToAppend}`
    }

    public entryPrecisionValue(entry) {
        return get(entry, this.precisionSubPath)
    }

    public vForKey() {
        vForKey++;
        return vForKey;
    }

    public get entriesList() {
        // entries can be undefined
        const { values } = this.form.getState();

        let entries = get(values, this.name);
        if (!entries) {
            entries = [];
            set(values, this.name, entries);
        }
        return entries;
    }

    public addEntry() {
        this.entriesList.push({
            id: this.vForKey(),
            typeIntervention: null
        })
    }

    public deleteEntry(index: number) {
        this.entriesList.splice(index, 1)
    }

}